import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const halfLen = Math.ceil(categories.length / 2);
  const col1 = categories.slice(0, halfLen);
  const col2 = categories.slice(halfLen);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-lg font-heading font-bold italic text-foreground-950 tracking-tight">
                OOPBuy <span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              The complete guide to smart shopping with spreadsheet-based product management. Optimize your workflow, compare prices, and track orders — all in one system.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">Quick Links</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">About</a></li>
              <li><a href="#features" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Features</a></li>
              <li><a href="#blog" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Blog</a></li>
              <li><a href="#safety" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">Safety Guide</a></li>
              <li><a href="#faq" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">Categories</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              {col1.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">More Categories</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              {col2.map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70 px-4 md:px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-heading font-black text-foreground-200 tracking-tight">OOPBuy</span>
            <span className="text-2xl font-heading font-black text-foreground-900 tracking-tight">Spreadsheet</span>
          </div>
          <p className="text-xs text-foreground-500 whitespace-nowrap">Smart Shopping System</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400">&copy; 2026 OOPBuy Spreadsheet Guide</span>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">
              <i className="ri-instagram-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}